interface Props {
  expenses: { description: string; amount: number; category: string; date: string }[];
  isPremium: boolean;
}

const fmt = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtDate = (d: string) => d ? new Date(d).toLocaleDateString('pt-BR') : '—';

const CATEGORY_COLORS: Record<string, string> = {
  Alimentação: 'bg-orange-100 text-orange-600',
  Moradia: 'bg-indigo-100 text-indigo-600',
  Transporte: 'bg-cyan-100 text-cyan-600',
  Saúde: 'bg-red-100 text-red-600',
  Educação: 'bg-violet-100 text-violet-600',
  Lazer: 'bg-pink-100 text-pink-600',
  Outros: 'bg-gray-100 text-gray-600',
};

export const TopSpending = ({ expenses, isPremium }: Props) => {
  const visible = isPremium ? expenses : expenses.slice(0, 5);
  const locked = expenses.length - visible.length;
  const max = expenses[0]?.amount ?? 1;

  if (!expenses.length) {
    return (
      <div className="flex flex-col items-center justify-center py-10 gap-2 text-center">
        <i className="ri-receipt-line text-3xl text-gray-200" />
        <p className="text-sm text-gray-400">Nenhuma despesa no período</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {visible.map((exp, i) => {
        const catStyle = CATEGORY_COLORS[exp.category] || 'bg-gray-100 text-gray-600';
        const barWidth = Math.round((exp.amount / max) * 100);
        return (
          <div key={i} className="flex items-center gap-3">
            <span className="text-[11px] font-700 text-gray-400 w-5 text-right shrink-0">{i + 1}</span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-[13px] text-gray-700 font-500 truncate pr-2">{exp.description}</span>
                <span className="text-[13px] font-700 text-gray-900 shrink-0">{fmt(exp.amount)}</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-red-300 rounded-full transition-all duration-500"
                    style={{ width: `${barWidth}%` }}
                  />
                </div>
                <span className={`text-[10px] font-600 px-1.5 py-0.5 rounded-full shrink-0 ${catStyle}`}>
                  {exp.category}
                </span>
                <span className="text-[11px] text-gray-400 shrink-0">{fmtDate(exp.date)}</span>
              </div>
            </div>
          </div>
        );
      })}
      {!isPremium && locked > 0 && (
        <div className="flex items-center gap-3 py-2 px-3 rounded-xl bg-amber-50 border border-amber-100 text-[12px] text-amber-600">
          <i className="ri-lock-line text-[14px] shrink-0" />
          <span>+{locked} maiores despesas disponíveis no plano Premium.</span>
        </div>
      )}
    </div>
  );
};
